export default [
    {
        path: "carrier/rule",
        name: "carrierRule",
        component: () => import(/* webpackChunkName: "carrier" */ "@/views/carrier/rule/index"),
    },
    {
        path: "carrier/rule/update/:type",
        name: "carrierUpdateRule",
        component: () => import(/* webpackChunkName: "carrier" */ "@/views/carrier/rule/update"),
    },
    {
        path: "carrier/extra",
        name: "carrierExtra",
        component: () => import(/* webpackChunkName: "carrier" */ "@/views/carrier/extra/index"),
    },
    {
        path: "carrier/extra/update/:type",
        name: "carrierUpdateExtra",
        component: () => import(/* webpackChunkName: "carrier" */ "@/views/carrier/extra/update"),
    },
    {
        path: "fedex/address",
        name: "fedexAddress",
        component: () => import(/* webpackChunkName: "fedex" */ "@/views/fedex/address"),
    },
    {
        path: "fedex/skucalc",
        name: "fedexSkucalc",
        component: () => import(/* webpackChunkName: "fedex" */ "@/views/fedex/skucalc"),
    },
    {
        path: "fedex/packagecalc",
        name: "fedexPackagecalc",
        component: () => import(/* webpackChunkName: "fedex" */ "@/views/fedex/packagecalc"),
    },
    {
        path: "fedex/costcalc",
        name: "fedexcostcalc",
        component: () => import(/* webpackChunkName: "fedex" */ "@/views/fedex/costcalc"),
    },
    {
        path: "fedex/ordercalc",
        name: "fedexOrdercalc",
        component: () => import(/* webpackChunkName: "fedex" */ "@/views/fedex/ordercalc"),
    },

    // 新增的页面
    {
        path: "fedex/basecost",
        name: "fedexBasecost",
        component: () => import(/* webpackChunkName: "fedex" */ "@/views/fedex/fedexcost/basecost/index"),
    },
    {
        path: "fedex/basecost/update/:type",
        name: "fedexUpdateBasecost",
        component: () => import(/* webpackChunkName: "fedex" */ "@/views/fedex/fedexcost/basecost/update"),
    },
    {
        path: "fedex/additionalrules",
        name: "fedexAdditionalrules",
        component: () => import(/* webpackChunkName: "fedex" */ "@/views/fedex/fedexcost/additionalrules/index"),
    },
    {
        path: "fedex/additionalrules/update/:type",
        name: "fedexUpdateAdditionalrules",
        component: () => import(/* webpackChunkName: "fedex" */ "@/views/fedex/fedexcost/additionalrules/update"),
    },
    {
        path: "fedex/discount",
        name: "fedexDiscount",
        component: () => import(/* webpackChunkName: "fedex" */ "@/views/fedex/fedexcost/discount/index"),
    },
    {
        path: "fedex/discount/update/:type",
        name: "fedexUpdateDiscount",
        component: () => import(/* webpackChunkName: "fedex" */ "@/views/fedex/fedexcost/discount/update"),
    },
    {
        path: "fedex/mincharge",
        name: "fedexMincharge",
        component: () => import(/* webpackChunkName: "fedex" */ "@/views/fedex/fedexcost/mincharge/index"),
    },
    {
        path: "fedex/mincharge/update/:type",
        name: "fedexUpdateMincharge",
        component: () => import(/* webpackChunkName: "fedex" */ "@/views/fedex/fedexcost/mincharge/update"),
    },

    {
        path: "fedex/billimport",
        name: "fedexBillimport",
        component: () => import(/* webpackChunkName: "fedex" */ "@/views/fedex/billimport/index"),
    },
    {
        path: "fedex/billimport/update/:type",
        name: "fedexUpdateBillimport",
        component: () => import(/* webpackChunkName: "fedex" */ "@/views/fedex/billimport/update"),
    },
    {
        path: "fedex/billimportdetail",
        name: "fedexBillimportdetail",
        component: () => import(/* webpackChunkName: "fedex" */ "@/views/fedex/billimportdetail/index"),
    },
    {
        path: "fedex/billimportdetail/update/:type",
        name: "fedexUpdateBillimportdetail",
        component: () => import(/* webpackChunkName: "fedex" */ "@/views/fedex/billimportdetail/update"),
    },

    {
        path: "fedex/costcheck",
        name: "fedexCostcheck",
        component: () => import(/* webpackChunkName: "fedex" */ "@/views/fedex/cost/costcheck"),
    },
    {
        path: "fedex/costdetail",
        name: "fedexCostdetail",
        component: () => import(/* webpackChunkName: "fedex" */ "@/views/fedex/cost/costdetail"),
    },

    {
        path: "fedex/settlement",
        name: "fedexSettlement",
        component: () => import(/* webpackChunkName: "fedex" */ "@/views/fedex/settlement/index"),
    },
    {
        path: "fedex/settlement/update/:type",
        name: "fedexUpdateSettlement",
        component: () => import(/* webpackChunkName: "fedex" */ "@/views/fedex/settlement/update"),
    },
    {
        path: "fedex/settlementdetail",
        name: "fedexSettlementdetail",
        component: () => import(/* webpackChunkName: "fedex" */ "@/views/fedex/settlementdetail/index"),
    },

    {
        path: "fedex/analyze/overview",
        name: "fedexAnalyzeOverview",
        component: () => import(/* webpackChunkName: "fedex" */ "@/views/fedex/analyze/overview"),
    },
    {
        path: "fedex/analyze/detail",
        name: "fedexAnalyzeDetail",
        component: () => import(/* webpackChunkName: "fedex" */ "@/views/fedex/analyze/detail.vue"),
    },
    {
        path: "fedex/analyze/package",
        name: "fedexAnalyzePackage",
        component: () => import(/* webpackChunkName: "fedex" */ "@/views/fedex/analyze/package"),
    },

    {
        path: "fedex/carrier/list",
        name: "fedexCarrierList",
        component: () => import(/* webpackChunkName: "fedex" */ "@/views/fedex/carrier/index"),
    },
    {
        path: "fedex/carrier/update/:type",
        name: "fedexCarrierUpdate",
        component: () => import(/* webpackChunkName: "fedex" */ "@/views/fedex/carrier/update"),
    },


    {
        path: "fedex/oversize/list",
        name: "fedexOversizeList",
        component: () => import(/* webpackChunkName: "fedex" */ "@/views/fedex/oversize/index"),
    },
    {
        path: "fedex/oversize/update/:type",
        name: "fedexOversizeUpdate",
        component: () => import(/* webpackChunkName: "fedex" */ "@/views/fedex/oversize/update"),
    },

]